import { useCallback, useRef } from 'react';
import { fetchBudgetServiceItems, IBudgetServiceItemOption } from '../../../../api/fetchBudget';
import BudgetSelectCustom from './BudgetSelectCustom';

interface IBudgetItemSelectProps {
  value: string;
  onChange: (option: { id: string; label: string; itemData?: IBudgetServiceItemOption } | undefined) => void;
  disabled?: boolean;
  isRemoved?: boolean;
  autoFocus?: boolean;
}

const BudgetItemSelect = (props: IBudgetItemSelectProps) => {
  const allDataRef = useRef<Array<{ id: string; label: string; value?: number; itemData?: IBudgetServiceItemOption }>>([]);

  const loadItemData = useCallback(
    async (
      searchTerm: string,
      pageSize: number,
      page: number,
    ): Promise<Array<{ id: string; label: string; value?: number; itemData?: IBudgetServiceItemOption }>> => {
      try {
        const items = await fetchBudgetServiceItems(searchTerm, pageSize, page);
        if (page === 1) {
          allDataRef.current = items;
        }
        return items;
      } catch (error) {
        console.error('[BudgetItemSelect] erro ao carregar dados', error);
        if (page === 1 && allDataRef.current.length > 0) {
          return allDataRef.current;
        }
        return [];
      }
    },
    [],
  );

  return (
    <BudgetSelectCustom
      value={props.value ? [props.value] : []}
      onChange={props.onChange}
      loadData={loadItemData}
      disabled={props.disabled}
      isRemoved={props.isRemoved}
      autoFocus={props.autoFocus}
          initialLimit={10}
      placeholder="Pesquisar"
      inputBorderColor="#14b8a6"
      inputBackgroundColor="#ffffff"
      dropdownBackgroundColor="#ffffff"
      highlightedOptionColor="#3b82f6"
      selectedOptionColor="#e5e7eb"
    />
  );
};

export default BudgetItemSelect;
